import {useRoute} from '@react-navigation/native';
import {
  Alert,
  BottomSheetDialog,
  Button,
  Div,
  Dropdown,
  HeaderBack,
  ImageView,
  InputItem,
  Label,
  LoadingIndicator,
  Toast,
} from 'components';
import {Ecolors, Icons, urlApp} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {Platform, ScrollView, StyleSheet} from 'react-native';
import {getInfo} from 'reducer/authen';
import {apiAuth, navigate, uploadFile, useImageUrl} from 'services';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import ComActionUpload from '../DigitalSignature/ComActionUpload';
import {getImageLibrary} from 'utils';

function EditAddressInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const [loading, setLoading] = useState<boolean>(false);
  const [isLike, setIsLike] = useState<boolean>(true);
  const control = useRef<boolean>(true);
  //
  const [permanentCountry, setPermanentCountry] = useState<any>(null);
  const [permanentProvince, setPermanentProvince] = useState<any>(null);
  const [permanentAddress, setPermanentAddress] = useState<string>('');
  //
  const [mailingCountry, setMailingCountry] = useState<any>(null);
  const [mailingProvince, setMailingProvince] = useState<any>(null);
  const [mailingAddress, setMailingAddress] = useState<string>('');
  const [localBase64, setLocalBase64] = useState<any>(null);
  const [loadingImg, setLoadingImg] = useState<any>(null);

  const route = useRoute<any>();
  const bottomSheet = useRef<any>(null);
  const {data} = route.params;
  const dispatch = useAppDispatch();

  const {userAddressIsFull, investmentProfile, addressChangeAttachmentUrl} =
    currentUser;

  const I18nState = useAppSelector(state => state.languages.I18nState);
  const isShowVnid =
    investmentProfile?.status?.code === 'INVESTMENT_PROFILE_ACCEPT' ||
    investmentProfile?.status?.code === 'INVESTMENT_PROFILE_APPROVE';

  const [imageSource, firstLoadingImg] = useImageUrl(
    `download/file-for-link`,
    'POST',
    `${addressChangeAttachmentUrl}`,
  );

  const finalSource = localBase64
    ? {uri: localBase64?.uri || ''}
    : {uri: imageSource.url || ''};

  useEffect(() => {
    bindData();
    return () => {};
  }, [currentUser]);

  useEffect(() => {
    if (!control.current) {
      if (!isLike) {
        setMailingCountry(null);
        setMailingProvince(null);
        setMailingAddress('');
      } else {
        setMailingCountry(permanentCountry || null);
        setMailingProvince(permanentProvince || null);
        setMailingAddress(permanentAddress);
      }
    }
    return () => {};
  }, [isLike]);

  const bindData = async () => {
    try {
      control.current = true;
      await Promise.all([
        setMailingCountry(data.mailingCountry || null),
        setMailingProvince(data.mailingProvince || null),
        setMailingAddress(currentUser?.mailingAddress),
        //
        setPermanentAddress(currentUser?.permanentAddress),
        setPermanentCountry(data.permanentCountry || null),
        setPermanentProvince(data.permanentProvince || null),
        //
        setIsLike(currentUser?.mailingAddress == currentUser?.permanentAddress),
      ]);
    } catch (error) {
    } finally {
      setTimeout(() => {
        control.current = false;
      }, 1000);
    }
  };

  const confirm = async () => {
    try {
      setLoading(true);
      if (
        !permanentCountry ||
        !permanentProvince ||
        !permanentAddress?.length ||
        !mailingCountry ||
        !mailingProvince ||
        !mailingAddress?.length ||
        (isShowVnid && !finalSource.uri)
      ) {
        Alert.showError({
          content: `alert.vuilongnhapdayduthongtindiachi`,
          onPress: () => {},
        });
        return;
      }

      const objData = {
        countryId: permanentCountry?.id || 234,
        provinceId: permanentProvince?.id,
        permanentAddress: permanentAddress,
        mailingCountryId: mailingCountry?.id || 234,
        mailingProvinceId: mailingProvince?.id,
        mailingAddress: mailingAddress,
        fileName: localBase64?.dataUpload?.fileName || null,
        url: localBase64?.dataUpload?.url || null,
      };

      const res = await (userAddressIsFull
        ? apiAuth.updateInvestmentAddressTypeUpdate(objData)
        : apiAuth.updateInvestmentAddress(objData));
      if (userAddressIsFull && res.data) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data,
            flowApp: 'UpdateAddressInfo',
          },
          onConfirm: () => {
            dispatch(getInfo({}));
            Alert.show({
              type: 2,
              titleClose: 'alert.dong',
              content: `alert.capnhatdiachithanhcong`,
              onConfirm: () => {
                navigate('AccountVerifyScreen');
              },
              onClose: () => {
                navigate('AccountVerifyScreen');
              },
              onCancel: () => {
                navigate('AccountVerifyScreen');
              },
            });
            return;
          },
        });
        return;
      }
      if (res.status == 200) {
        dispatch(getInfo({}));
        Alert.show({
          type: 2,
          titleClose: 'alert.dong',
          content: `alert.capnhatdiachithanhcong`,
          onConfirm: () => {
            navigate('AccountVerifyScreen');
          },
          onClose: () => {
            navigate('AccountVerifyScreen');
          },
          onCancel: () => {
            navigate('AccountVerifyScreen');
          },
        });
        return;
      }
      Alert.showError({
        content: I18nState == 'vi' ? res.message : res.messageEn,
        multilanguage: false,
        onPress: () => {
          navigate('AccountVerifyScreen');
        },
      });
      return;
    } catch (error: any) {
      Alert.showError({
        content: I18nState == 'vi' ? error.message : error.messageEn,
        multilanguage: false,
        onPress: () => {},
      });
      return;
    } finally {
      setLoading(false);
    }
  };

  const hide = (cb?: () => void) => {
    if (bottomSheet.current) {
      bottomSheet.current.hide().then(() => {
        if (cb) {
          cb();
        }
      });
    }
  };

  const onUploadImage = async (res: any) => {
    try {
      setLoadingImg(true);
      const dataUpload: any = await uploadFile({
        fileBase64: res.base64,
      });
      if (dataUpload) {
        console.log('dataUpload>', {...res, dataUpload});
        setLocalBase64({...res, dataUpload});
      } else {
        Toast.show({
          content: 'alert.daxayraloi',
          multilanguage: true,
        });
      }
    } catch (error) {
    } finally {
      setLoadingImg(false);
    }
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        titleRight={`accountverify.save`}
        loading={loading}
        onRightPress={() => {
          confirm();
        }}
        title={`accountverify.thongtindiachi`}
      />
      <ScrollView>
        {/* dia chi thuong tru */}
        <Div padding={16} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`1. `}
            <Label>{`accountverify.diachithuongtru`}</Label>
          </Label>
        </Div>
        <Div paddingHorizontal={16}>
          <Label marginTop={13}>{`accountverify.quocgia`}</Label>
          <Dropdown
            url={`country/list`}
            content={`accountverify.vuilongchonquocgia`}
            multilanguage={true}
            value={permanentCountry}
            paddingHorizontal={0}
            marginTop={6}
            isActive={true}
            onChange={(a: any) => {
              if (isLike) {
                setMailingCountry(a);
              }
              setPermanentCountry(a);
              setPermanentProvince(null);
            }}
          />
          <Label marginTop={13}>{`accountverify.tinhthanhpho`}</Label>
          <Dropdown
            url={`province/list?countryId=${permanentCountry?.id || 234}`}
            content={`accountverify.vuilongchontinhthanhpho`}
            multilanguage={true}
            value={permanentProvince}
            paddingHorizontal={0}
            marginTop={6}
            isActive={!!permanentCountry}
            onChange={(a: any) => {
              if (isLike) {
                setMailingProvince(a);
              }
              setPermanentProvince(a);
            }}
          />

          <Label marginTop={16}>{`accountverify.diachithuongtru`}</Label>
          <InputItem
            multiline
            value={permanentAddress}
            isInput={!!permanentCountry && !!permanentProvince}
            onChangeText={(a: string) => {
              setPermanentAddress(a);
              if (isLike) {
                setMailingAddress(a);
              }
            }}
            marginHorizontal={0}
            marginTop={6}
          />

          {isShowVnid && (
            <>
              <Label marginTop={16}>{`accountverify.vnid`}</Label>
              <Div
                paddingHorizontal={0}
                paddingTop={6}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}>
                <Button
                  overflow={'hidden'}
                  borderRadius={5}
                  width={162}
                  onPress={() => {
                    if (!loadingImg || !firstLoadingImg) {
                      bottomSheet.current.show();
                    }
                  }}
                  height={103}>
                  <ImageView
                    borderRadius={5}
                    width={162}
                    height={103}
                    source={{
                      uri: finalSource.uri,
                    }}
                  />
                  <Div
                    style={StyleSheet.absoluteFillObject}
                    alignItems={'center'}
                    justifyContent={'center'}
                    flex={1}
                    backgroundColor={Ecolors.transparentLoading}>
                    {loadingImg || firstLoadingImg ? (
                      <LoadingIndicator color={Ecolors.mainColor} />
                    ) : (
                      <ImageView
                        width={26}
                        height={24}
                        resizeMode={'contain'}
                        tintColor={Ecolors.whiteColor}
                        source={Icons.camera}
                      />
                    )}
                  </Div>
                </Button>
              </Div>
            </>
          )}
        </Div>
        {/* dia chi lien he */}
        <Div padding={16} marginTop={21} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`2. `}
            <Label>{`accountverify.diachilienhe`}</Label>
          </Label>
        </Div>

        <Div paddingHorizontal={16}>
          <Div
            marginTop={19}
            backgroundColor={Ecolors.bgtime}
            borderRadius={5}
            padding={5}
            flexDirection={'row'}
            alignItems={'center'}>
            <Div
              flex={1}
              justifyContent={'center'}
              alignItems={'center'}
              backgroundColor={isLike ? Ecolors.whiteColor : Ecolors.bgtime}
              borderRadius={5}>
              <Button
                justifyContent={'center'}
                alignItems={'center'}
                onPress={() => {
                  setIsLike(true);
                }}
                paddingVertical={10}>
                <Label>{`accountverify.giongdiachithuongtru`}</Label>
              </Button>
            </Div>
            <Button
              onPress={() => {
                setIsLike(false);
              }}
              padding={10}
              borderRadius={5}
              alignItems={'center'}
              justifyContent={'center'}
              backgroundColor={!isLike ? Ecolors.whiteColor : Ecolors.bgtime}
              marginLeft={5}>
              <Label>{`accountverify.diachikhac`}</Label>
            </Button>
          </Div>
          <Label marginTop={13}>{`accountverify.quocgia`}</Label>
          <Dropdown
            url={`country/list`}
            content={`accountverify.vuilongchonquocgia`}
            multilanguage={true}
            value={mailingCountry}
            paddingHorizontal={0}
            marginTop={6}
            isActive={true}
            onChange={(a: any) => {
              setMailingCountry(a);
              setMailingProvince(null);
            }}
          />
          <Label marginTop={13}>{`accountverify.tinhthanhpho`}</Label>
          <Dropdown
            url={`province/list?countryId=${mailingCountry?.id || 234}`}
            content={`accountverify.vuilongchontinhthanhpho`}
            multilanguage={true}
            value={mailingProvince}
            paddingHorizontal={0}
            marginTop={6}
            isActive={!!mailingCountry}
            onChange={(a: any) => {
              setMailingProvince(a);
            }}
          />

          <Label marginTop={16}>{`accountverify.diachilienhe`}</Label>
          <InputItem
            value={mailingAddress}
            isInput={!!mailingCountry && !!mailingProvince}
            onChangeText={setMailingAddress}
            marginHorizontal={0}
            marginTop={6}
          />
        </Div>
        <Div height={350} />
      </ScrollView>
      {/* bottom sheet
       */}
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheet}>
        <ComActionUpload
          onCancel={() => {
            hide();
          }}
          onCamera={() => {}}
          onGallery={async () => {
            try {
              // if (Platform.OS === 'ios') {
              //   await getImageLibrary().then((image: any) => {
              //     hide();
              //     if (image[0]) {
              //       if (image[0].uri.endsWith('.gif')) {
              //         Alert.showError({
              //           content: 'alert.dinhdanganhkhongphuhop',
              //         });
              //         return;
              //       }
              //       doAction(image[0]);
              //     }
              //   });
              //   return;
              // }
              hide(async () => {
                await getImageLibrary().then(async (image: any) => {
                  if (image?.[0]) {
                    if (image[0].uri.endsWith('.gif')) {
                      Alert.showError({
                        content: 'alert.dinhdanganhkhongphuhop',
                      });
                      return;
                    }
                    return onUploadImage(image[0]);
                  }
                });
              });
              return;
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
                return;
              }
            } finally {
              hide(async () => {});
            }
          }}
        />
      </BottomSheetDialog>
    </Div>
  );
}

export default React.memo(EditAddressInfoModal);
